import React from "react";
import PropTypes from "prop-types";

import ProductDetailsTags from "../ProductDetailsTags";
import {
  InfoBoxItemDescriptionHolderHead,
  InfoBoxItemDescriptionHolderHeadButton,
  InfoBoxItemDescriptionHolderHeadButtons,
} from "../SpecialInfoBoxItem";
import ShareLinkButton from "../ShareLinkButton";
import BookmarkIcon from "../BookmarkIcon";
import urlPatterns from "../../../urls";
import { trackingEvents, useTrackEvent } from "../../../helpers/Analytics";
import { WINE_LIST_SLUGS } from "../../../helpers/constants";

const WineTagsShareAndBookmark = ({
  wine,
  tagsBgColor,
  isInBoxAndCartTray = false,
  handleWineListsPanelChange,
  handleToggleBottleInfoTray = () => {},
}) => {
  const trackEvent = useTrackEvent();

  /**
   * Gets the wine details tags from GET_WINE_NAME_AND_LARGE_PHOTO query,
   * and returns the Wine Class name, Grape Type, Wine Region, and Country in an array.
   *
   * @returns {Object}
   * */
  const getWineDetailsTagNames = () => {
    const tags = {
      wineClassName: wine.wineType && wine.wineType.wineClass && wine.wineType.wineClass.name,
      wineTypeName: wine.wineType && wine.wineType.name,
      wineRegionName: wine.wineRegion && wine.wineRegion.name,
      wineRegionState: wine.wineRegion && wine.wineRegion.state,
      wineCountryName: wine.country && wine.country.name,
      wineMakerName: wine.wineMaker && wine.wineMaker.name,
    };
    return tags;
  };

  const { product, isBookmarked } = wine;
  const { slug } = product || {};
  const wineUrl = `${import.meta.env.REACT_APP_BASE_URL}${urlPatterns.WINE_DETAILS(slug)}`;

  // Tracking event to trigger on share button click
  const shareButtonClickTrack = () => {
    trackEvent(trackingEvents.TRACKING_EVENT_CLICKED_WINE_SHARE_BUTTON, {
      wine_url: wineUrl,
    });
  };

  // Tracking event to trigger on copy link action
  const copyLinkClickTrack = () => {
    trackEvent(trackingEvents.TRACKING_EVENT_COPIED_WINE_SHARE_LINK, {
      wine_url: wineUrl,
    });
  };

  return (
    <InfoBoxItemDescriptionHolderHead>
      <ProductDetailsTags
        tags={getWineDetailsTagNames()}
        color={tagsBgColor}
        handleToggleBottleInfoTray={handleToggleBottleInfoTray}
        pathname={urlPatterns.WINE_LIST(WINE_LIST_SLUGS.ALL_WINES)}
      />

      <InfoBoxItemDescriptionHolderHeadButtons>
        <ShareLinkButton
          isInBoxAndCartTray={isInBoxAndCartTray}
          urlLink={wineUrl}
          shareButtonClickTrack={shareButtonClickTrack}
          copyLinkClickTrack={copyLinkClickTrack}
        />
        <InfoBoxItemDescriptionHolderHeadButton onClick={handleWineListsPanelChange}>
          <BookmarkIcon isBookmarked={isBookmarked} />
        </InfoBoxItemDescriptionHolderHeadButton>
      </InfoBoxItemDescriptionHolderHeadButtons>
    </InfoBoxItemDescriptionHolderHead>
  );
};

WineTagsShareAndBookmark.propTypes = {
  tagsBgColor: PropTypes.string.isRequired,
  isInBoxAndCartTray: PropTypes.bool,
  handleWineListsPanelChange: PropTypes.func.isRequired,
  handleToggleBottleInfoTray: PropTypes.func,
  wine: PropTypes.shape({
    id: PropTypes.number,
    isBookmarked: PropTypes.bool,
    product: PropTypes.shape({
      slug: PropTypes.string,
      name: PropTypes.string,
    }),
    wineType: PropTypes.shape({
      wineClass: PropTypes.shape({
        name: PropTypes.string,
      }),
      name: PropTypes.string,
    }),
    wineRegion: PropTypes.shape({
      name: PropTypes.string,
      state: PropTypes.string,
    }),
    country: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
};

export default WineTagsShareAndBookmark;
